export default {
  viewType: 'form',
  module: '/system/spec/productStrategy/',
  callBackAction: 'productStrategyOkActionCb',
  params: {},
  okAction: 'edit',
  toolbar: {},
  needFetchFillInfo: true,
  fillDetailUrl: `/system/spec/productStrategy/detail`,
  view: {
    showCancelBtn: false,
    labelPosition: 'right',
    width: '700px',
    labelWidth: '245px',
    content: [
      {
        $id: 'sysProductPriorityStrategyDTOList',
        label: '产品版本选择优先级策略',
        $type: 'sky-product-priority-strategy',
        rules: [{ notEmpty: '产品版本选择优先级策略' }]
      },
      {
        $id: 'sysProductLimitStrategyDTOList',
        label: '产品版本依赖限制',
        $type: 'sky-product-limit-strategy'
      }
    ]
  }
}
